import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Account } from '@app/models/account';
import { AccountType } from "@app/models/account-type";
import { AccountTypeService } from "@app/services/account-type.service";
import { GlobalErrorHandlerService } from "@app/services/global-error-handler.service";
import { NotificationService } from "@app/services/notification.service";

@Component({
    selector: 'app-user-account-list',
    templateUrl: './user-account-list.component.html',
    styleUrls: ['./user-account-list.component.css'],
    standalone: false
})
export class UserAccountListComponent implements OnInit {

  @Input() selectedAccount: any;
  @Input() hideClosedAccount: boolean;
  @Input() loadAccount: boolean;
  @Input() allowSelectAccountType: boolean;
  @Input() kindOfAccountType: number;
  @Input() isForeignCurrencyAccount: boolean;
  @Input() currency: string;
  @Output() addAccount = new EventEmitter<Account>();
  @Output() deleteAccountFromList = new EventEmitter();
  @Output() addAccountType = new EventEmitter<AccountType>();

  errorMessage: string | boolean;
  infoMessage: string;
  pageSize: number = 9999;
  pageIndex: number = 0;
  accountTypes: Array<AccountType>;

  defaultPageParams = {
    size: 10000,
    page: 0
  }

  constructor(
    private accountTypeService: AccountTypeService,
    private notificationService: NotificationService,
    private errorService: GlobalErrorHandlerService
  ) { }

  ngOnInit(): void {
    this.getAccountTypesList();
    if (this.loadAccount === undefined) {
      this.loadAccount = true;
    }
    if (this.allowSelectAccountType === undefined) {
      this.allowSelectAccountType = false;
    }
    if (this.hideClosedAccount === undefined) {
      this.hideClosedAccount = true;
    }
  }

  getAccountTypesList() {
    const pageOption = {
      size: this.pageSize,
      page: this.pageIndex,
      sorted: true,
      parent: true
    }

    const pageParams = { ...this.defaultPageParams, ...pageOption };
    this.accountTypeService.getSortedList(pageParams).subscribe({
      next: (data) => {
        if (this.kindOfAccountType == 1) {
          this.accountTypes = data.content.filter(p => p.balanceType != "OFF_BALANCE" && p.enabled);
        } else if (this.kindOfAccountType == 2) {
          this.accountTypes = data.content.filter(p => p.balanceType == "OFF_BALANCE" && p.enabled);
        } else {
          this.accountTypes = data.content.filter(p => p.enabled);
        }

        const filterEnabledSubAccounts = (account: AccountType): AccountType => {
          if (!account.subAccounts?.length) {
            return account;
          }
  
          return {
            ...account,
            subAccounts: account.subAccounts
              .filter(subAccount => subAccount.enabled)
              .map(subAccount => filterEnabledSubAccounts(subAccount))
          };
        };
  
        this.accountTypes = this.accountTypes.map(account => filterEnabledSubAccounts(account));
      },
      error: (err) => {
        this.errorMessage = this.errorService.handleError(err);
        if(this.errorMessage)
        this.notificationService.showError("<div class='row'><p class='col-1 d-flex align-items-center'><i class='fa fa-times-circle'></i></p><p class='col'> " + `${this.errorMessage}` + "</p></div>",
                "");
      }
    });
  }

  composeAccountType(accountType: AccountType) {
    if (accountType) {
      this.addAccountType.emit(accountType)
    }
  }

  composeAccount(account: Account) {
    if (account) {
      this.addAccount.emit(account)
    }
  }

  removeAccount() {
    this.deleteAccountFromList.emit();
  }
}
